<mat-form-field>
    <mat-label matTooltip="Preview text for the link">Link Text</mat-label>
    <input matInput type="text" [(ngModel)]="linkText">
</mat-form-field>

<mat-form-field>
    <mat-label matTooltip="URL that the link points to">Link URL</mat-label>
    <input matInput type="text" [(ngModel)]="linkUrl">
</mat-form-field>

<div style="flex: 1"></div>

<div style="display: flex; justify-content: end;">
    <button mat-flat-button (click)="applyChanges()">

        @if (isSaving) {
            <mat-progress-spinner
                mode="indeterminate"
                [diameter]="18"
                style="display: inline"
            />
        }
        @else {
            <mat-icon>check</mat-icon>
        }

        Ok
    </button>
    <button mat-flat-button (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
        Cancel
    </button>
</div>
